import { Injectable } from "@angular/core";
import { SiteModel } from "../models/site.model";
import { CameraModel } from "../models/camera.model";


@Injectable({
  providedIn: 'root',
})
export class CsvService {
  // Variables

  constructor() { }

  /**
   * Create a CSV file containing all cameras for a given site
   * and trigger a download in the browser
   * @param  {SiteModel} site - Site with cameras to include in the CSV
   * @param  {string} fileName - Desired file name for the downloaded CSV
   */
  createSiteCameraInventoryCsv(site: SiteModel, fileName: string) {
    const csvRows = [];

    // Add header row
    csvRows.push('Site Name,Camera Name,IP Address,MAC Address,Resolution,Camera Model,Service Date,Last Sync');

    // Add data rows
    site.Cameras.forEach(camera => {
      csvRows.push([this.escapeCSV(site.Name), ...this.createCameraRow(camera)].join(','));
    });

    // Create CSV string
    const csvContent = csvRows.join('\n');

    // Create blob and download
    this.createAndDownloadBlob(csvContent, fileName);
  }

  /**
   * Create a CSV file containing all cameras for all sites
   * and trigger a download in the browser
   * @param  {SiteModel[]} sites - List of sites with cameras
   * @param  {string} fileName - Desired file name for the downloaded CSV
   */
  createAllSitesCameraInventoryCsv(sites: SiteModel[], fileName: string) : void {
    const csvRows = [];

    // Add header row
    csvRows.push('Site Name,Camera Name,IP Address,MAC Address,Resolution,Camera Model,Service Date,Last Sync');

    sites.forEach(site => {
      site.Cameras.forEach(camera => {
        csvRows.push([this.escapeCSV(site.Name), ...this.createCameraRow(camera)].join(','));
      });
    });
    const csvContent = csvRows.join('\n');
    this.createAndDownloadBlob(csvContent, fileName);
  }

  private createAndDownloadBlob(content: string, fileName: string) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private createCameraRow(camera: CameraModel): string[] {
    return [
      this.escapeCSV(camera.Name),
      this.escapeCSV(camera.IpAddress),
      this.escapeCSV(camera.MacAddress),
      this.escapeCSV(camera.Resolution),
      this.escapeCSV(camera.Model),
      this.escapeCSV(camera.ServiceDate ? new Date(camera.ServiceDate).toLocaleString('en-US') : ''),
      this.escapeCSV(camera.LastSync ? new Date(camera.LastSync).toLocaleString('en-US') : '')
    ];
  }

  private escapeCSV(value: string): string {
    if (!value) return '';

    const stringValue = value.toString();

    // If value contains comma, quote, or newline, wrap in quotes and escape internal quotes
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
  }

}
